import { Decorators, EntityDialog, TemplatedDialog } from "@serenity-is/corelib";

@Decorators.registerClass('Watersource.Common.MarketInformationInfoDialog')
@Decorators.panel(false)
export class MarketInformationInfoDialog<P = {}> extends TemplatedDialog<P> {

    protected getDialogOptions() {
        var opt = super.getDialogOptions();
        opt.buttons = [
            {
                text: "Ok",
                click: () => {
                    this.dialogClose();
                }
            }
        ];

        return opt;
    }

    public okClick: () => void;

    protected getTemplate() {
        return `
            <div style="margin: 20px;">
                <h3>What is Market Information?</h3>
                <p>
                    The UK water industry regulator Ofwat, requires water companies to publish key information in a consistent format to support the need to bid for water resources, demand management and leakage services. This is called Market Information. More information can be found on the Ofwat website
                    <a href="https://www.ofwat.gov.uk/regulated-companies/markets/water-bidding-market/water-resources-market-information/" target="_blank" rel="noopener noreferrer">here</a>.
                </p>
                <p>
                    Market Information is published alongside a water company's Water Resources Management Plan (WRMP), providing a forecast for each Water Resource Zone (WRZ) in relation to public water supply and demand risks for the next 25+ years.
                </p>
                <p>
                    This information is published so that third-parties can put forward options, or bid, on how they would supply water,
                    manage future demand or provide leakage services to help overcome the supply/demand risks.
                </p>
                <p>
                    In some cases they may be two forecasts for a zone:
                    <ul>
                        <li>
                            Dry Year Annual Average (DYAA) – this is the average level of water demand in a dry year.
                            This ‘dry year annual average’ is considered to represent a period of low rainfall and unrestricted demand.
                            The constraints on water supply for the DYAA scenario are typically group licences limited by the amount of water
                            that can be abstracted.
                        </li>
                        <li>
                            Dry Year Critical Period (DYCP) – this is a peak period defined as 3 days, which relates    
                            to observed demand peaks and operational processes. The constraints on water supply for the DYCP scenario are
                            typically water treatment works capacity limited by the amount of water that can be treated at one time.
                        </li>
                    </ul>
                    <h3>What are Water Resource Zones or WRZs?</h3>
                </p>
                <p>
                    Water Resource Zones are geographical areas, linked by supply infrastructure,
                    that are used by water companies to develop forecasts of supply and demand and supply vs demand balances.
                    <h3>
                    What is the Bid Assessment Framework?
                </h3>
                </p>
                <p>
                    Ofwat requires all water companies produce a bid assessment
                    framework to allow third parties to submit options to provide solutions to help meet future water needs.
                <h3> How does Wheatley Watersource and the Market Information Explorer help?</h3>
                </p>
                <p>
                    The Wheatley Watersource Market Information Explorer provides the Market Information for participating water companies in one place, so third parties can make contact to raise a query or offer assistance.
                </p>
                <a href='/content/site/documentation/Watersource Privacy Policy Oct 2020.pdf' target="_blank">
                    Click here for Watersource privacy policy
                </a>
        </div>
        `;
    }
}
